import { PublicPageTemplate } from "./PublicPageTemplate";

const VisionPage = () => (
  <PublicPageTemplate
    badge="Notre Vision"
    title="Démocratiser l'IA pour les"
    highlight="entrepreneurs"
    description="Notre mission : rendre l'intelligence artificielle accessible à chaque entrepreneur, chaque PME, chaque porteur de projet."
  />
);
export default VisionPage;
